import { buildAction } from 'store/actions/actionCreator'

import { SIDE_MENU_TOGGLE } from './constants'

export const toggleMenu = buildAction(SIDE_MENU_TOGGLE)
